module.exports = __webpack_public_path__ + "media/images/shared/suppliers/DINEX-212f6da341666737473896d36a10ed59.jpg";